import { mailClient } from './client'
import type { Mailbox, Email, MailAuditLog, ServiceConfigParam } from '../types'

// ── Mailboxes ─────────────────────────────────────────────────────────────────
export const getMailboxes = () =>
  mailClient.get<Mailbox[]>('/mailboxes')

export const getMailbox = (id: string) =>
  mailClient.get<Mailbox>(`/mailboxes/${id}`)

export interface MailboxInput {
  name: string; host: string; port: number; user: string; password?: string; tls?: boolean
  isActive?: boolean; storageDatasetId?: string | null
  smtpEnabled?: boolean; smtpHost?: string | null; smtpPort?: number | null; smtpSecure?: boolean
  // smtpUser/smtpPassword empty = use the receiving login; smtpPassword omitted = keep the stored one.
  smtpUser?: string | null; smtpPassword?: string | null; smtpFromName?: string | null; smtpFromAddress?: string | null
}

export const createMailbox = (data: MailboxInput) =>
  mailClient.post<Mailbox>('/mailboxes', data)

export const updateMailbox = (id: string, data: Partial<MailboxInput>) =>
  mailClient.put<Mailbox>(`/mailboxes/${id}`, data)

// Sends a short test email from the mailbox (its sending settings must be saved first).
export const sendMailboxTest = (id: string, to: string) =>
  mailClient.post<{ sent: boolean; messageId: string }>(`/mailboxes/${id}/send-test`, { to })

export const deleteMailbox = (id: string) =>
  mailClient.delete(`/mailboxes/${id}`)

export const checkMailbox = (id: string) =>
  mailClient.post(`/mailboxes/${id}/check`)

// ── Emails ────────────────────────────────────────────────────────────────────
export const getEmails = (params?: { mailboxId?: string; limit?: number }) =>
  mailClient.get<Email[]>('/emails', { params })

export const markEmailAsRead = (id: string) =>
  mailClient.patch(`/emails/${id}/read`)

export const deleteEmail = (id: string) =>
  mailClient.delete(`/emails/${id}`)

// ── Audit Logs ────────────────────────────────────────────────────────────────
export const getMailAuditLogs = (params?: { action?: string; mailboxId?: string; limit?: number }) =>
  mailClient.get<MailAuditLog[]>('/audit-logs', { params })

// ── Config ────────────────────────────────────────────────────────────────────
export const getMailConfig = () =>
  mailClient.get<ServiceConfigParam[]>('/config')

export const setMailConfig = (key: string, value: string) =>
  mailClient.post('/config', { [key]: value })
